<template>
  <!--begin::Footer-->
  <div
    class="footer py-4 d-flex flex-lg-column"
    id="kt_footer"
    style="flex-direction: column;"
  >
    <!--begin::Container-->

    <div class="container text-white">
      <div
        style="display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-between;"
      >
        <div class="mb-5">
          <div class="my-5">
            <img src="media/image-app/logo-footer.svg" alt="" class="w-100" />
          </div>
          <div class="my-5">
            <img src="media/image-app/logo2.svg" alt="" class="w-100" />
          </div>
        </div>
        <div>
          <b>กลุ่มวิชาการ</b>
          <p class="mb-5" style="font-size: 14px;">
            กองพัฒนาทรัพยากรบุคคลด้านพลังงาน<br />
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน <br />
            กระทรวงพลังงาน
          </p>
          <p style="font-size: 14px;">
            ต. คลองห้า อ. คลองหลวง จ. ปทุมธานี 12120 <br />
            โทรศัพท์ 0 2577 7035-41<br />
            โทรสาร 0 2577 7047
          </p>
        </div>
        <div>
          <p
            class="mb-3 w-100 text-white cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_verify_cert"
          >
            <i class="fas fa-search text-white me-2"></i><u>ตรวจสอบใบรับรอง</u>
          </p>
          <p
            class="mb-3 w-100 text-white cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_survey"
          >
            <i class="fas fa-poll text-white me-2"></i><u>แบบสำรวจความพึงพอใจ</u>
          </p>
          <b>Social Media</b>
          <div style="display: flex;">
            <router-link to="/https://www.facebook.com/PREbyDEDE" target="_blank">
              <img class="mx-1" src="media/image-app/Facebook.svg" alt="" />
            </router-link>
            <a href="#" target="_blank">
              <img class="mx-1" src="media/image-app/Youtube.svg" alt="" />
            </a>
            <a href="#" target="_blank">
              <img class="mx-1" src="media/image-app/Mail.svg" alt="" />
            </a>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div
      class="d-flex flex-column flex-md-row align-items-center justify-content-between"
      :class="{
        'container-fluid': footerWidthFluid,
        container: !footerWidthFluid,
      }"
    >
      <!--begin::Copyright-->
      <div class="text-dark order-2 order-md-1">
        <span class="text-muted fw-bold me-1"
          >&copy; Copy right 2019 . All rights reserved</span
        >
        <!-- <a
          href="https://keenthemes.com/"
          target="_blank"
          class="text-gray-800 text-hover-primary"
          >Keenthemes</a
        > -->
      </div>
      <!--end::Copyright-->

      <!--begin::Menu-->
      <ul class="menu menu-gray-600 menu-hover-primary fw-bold order-1">
        <li class="menu-item">
          <router-link to="/contactus" target="_blank" class="menu-link px-2">เกี่ยวกับเรา</router-link>
        </li>

        <li class="menu-item">
          <router-link to="/terms" target="_blank" class="menu-link px-2"
            >ข้อกำหนดและเงื่อนไขการใช้งาน</router-link
          >
        </li>

        <li class="menu-item">
          <router-link to="/policy" target="_blank" class="menu-link px-2"
            >นโยบายความเป็นส่วนตัว</router-link
          >
        </li>

        
      </ul>
      <!--end::Menu-->
    </div>
    <!--end::Container-->
  </div>
  <!--end::Footer-->

  <!-- Modal ตรวจสอบใบรับรอง -->
  <div class="modal fade" tabindex="-1" id="kt_modal_verify_cert">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header"
          style="background: #FFF; border-radius: 0.475rem 0.475rem 0 0;"
        >
          <h5 class="modal-title text-dark fw-bold">ตรวจสอบใบรับรอง</h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <label class="form-label fw-bold text-dark fs-6"
            >กรอกหมายเลขใบรับรองที่ต้องการ</label
          >
          <div class="input-group">
            <input
              type="text"
              class="form-control form-control-solid"
              placeholder="กรอก"
              v-model="certNo"
            />
          </div>
          <div class="text-center">
            <button
              class="btn my-5 "
              style="background: #323563; color: #FFF;border-radius: 20px;min-width: 150px;"
              @click="searchCertificate"
            >
              <i class="fas fa-search text-white"></i> ตรวจสอบ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal แบบสำรวจความพึงพอใจ -->
  <div class="modal fade" tabindex="-1" id="kt_modal_survey">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 1024px;">
      <div class="modal-content">
        <div
          class="modal-header"
          style="background: #FFF; border-radius: 0.475rem 0.475rem 0 0;"
        >
          <h5 class="modal-title text-dark fw-bold">แบบสำรวจความพึงพอใจ</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div style="text-align:right;margin-bottom:12px;">
            <a
              href="https://forms.gle/HTcZF2y9hBN9ebzr5"
              target="_blank"
              rel="noopener noreferrer"
              class="btn btn-sm btn-light-primary"
            >
              <i class="fa fa-external-link-alt"></i> เปิดในแท็บใหม่
            </a>
          </div>
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSd9yOUDteG-me0s44L8xNfPiWnvXeOIy3OOZgrL7y3JKXRj6A/viewform?embedded=true"
            width="100%"
            height="1024"
            frameborder="0"
            style="max-width:100%;border:none;"
          >กำลังโหลด…</iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { footerWidthFluid } from "@/core/helpers/config";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import router from "@/router";
import axios from "axios";

export default defineComponent({
  name: "KTFooter",
  setup() {
    const certNo = ref("");

    const searchCertificate = async () => {
      if (!certNo.value.trim()) {
        Swal.fire({
          text: "กรุณากรอกเลขที่ใบรับรอง",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn fw-semibold btn-light-warning",
          },
        });
        return;
      }

      try {
        const headers = { token: localStorage.getItem("id_token") };
        const params = "?certificateNumber=" + certNo.value.trim();

        const [courseRes, syllabusRes] = await Promise.allSettled([
          axios.get(process.env.VUE_APP_API_URL + "/getCourseCertificate" + params, { headers }),
          axios.get(process.env.VUE_APP_API_URL + "/getSyllabusCertificate" + params, { headers }),
        ]);

        const courseData =
          courseRes.status === "fulfilled" && courseRes.value.data?.code === 200 && courseRes.value.data.data.content.length > 0
            ? courseRes.value.data.data.content
            : null;
        const syllabusData =
          syllabusRes.status === "fulfilled" && syllabusRes.value.data?.code === 200 && syllabusRes.value.data.data.content.length > 0
            ? syllabusRes.value.data.data.content
            : null;

        if (courseData && courseData.length > 0 || syllabusData && syllabusData.length > 0) {
          Swal.fire({
            text: "พบใบรับรองเลขที่ " + certNo.value,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semibold btn-light-success",
            },
          });
        } else {
          Swal.fire({
            text: "ไม่พบใบรับรองเลขที่ " + certNo.value,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semibold btn-light-danger",
            },
          });
        }
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn fw-semibold btn-light-danger",
          },
        });
      }
    };

    return {
      footerWidthFluid,
      certNo,
      searchCertificate,
    };
  },
});
</script>
<style scoped>
.footer {
  background: #323563;
}
hr {
  background-color: #ffffff;
}
</style>
